import { Component, EventEmitter, Output } from '@angular/core';

export interface DateFilterValue {
  type: 'thisMonth' | 'lastMonth' | 'custom';
  startDate?: string;
  endDate?: string;
}

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.css']
})
export class DateFilterComponent {
  @Output() filterChange = new EventEmitter<DateFilterValue>();

  activeFilter: 'thisMonth' | 'lastMonth' | 'custom' = 'thisMonth';
  showCustomInputs: boolean = false;
  customStartDate: string = '';
  customEndDate: string = '';

  selectPreset(filter: 'thisMonth' | 'lastMonth'): void {
    this.activeFilter = filter;
    this.showCustomInputs = false;
    this.filterChange.emit({ type: filter });
  }

  openCustom(): void {
    this.showCustomInputs = true;
  }

  applyCustom(): void {
    this.activeFilter = 'custom';
    this.filterChange.emit({
      type: 'custom',
      startDate: this.customStartDate,
      endDate: this.customEndDate
    });
  }

  closeCustom(): void {
    this.showCustomInputs = false;
    // Fall back to "This Month" since Custom was never applied (or to
    // revert away from a previously-applied custom range).
    this.activeFilter = 'thisMonth';
    this.filterChange.emit({ type: 'thisMonth' });
  }
}
